import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import { WarningIcon } from 'assets/materialIcons/materialIcons';

const Container = styled.span`
    position: absolute;
    display: none;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);

    @media screen and (min-width: 767px) {
        display: block;
    }
`;

const Icon = styled(WarningIcon)`
    height: 22px;
    width: 22px;
    opacity: 0.8;
    pointer-events: none;
`;

const ErrorIcon = (props) => {
    const { error } = props;

    if (!error) {
        return;
    }

    return (
        <Container>
            <Icon color={ theme.palette.redOrange } />
        </Container>
    );
};

ErrorIcon.propTypes = {
    error: PropTypes.bool.isRequired,
};

export default ErrorIcon;



// WEBPACK FOOTER //
// ./src/components/tabs/tab/ErrorIcon.js